module.exports = __webpack_public_path__ + "static/img/redis.bfe086f4.svg";